import React from "react";
import "./leftSideContent.scss";
import DummyImage from "../../../../assets/images/2.png";
import { NavLink } from "react-router-dom";
export default function LeftSideContent() {
  return (
    <div>
      <div className="provisionsfrei-left-side-content-alignment">
        <div className="grid">
          <div className="grid-items">
            <div className="image-style">
              <NavLink to="/kontakt">
                <img
                  className="animate__backInUp animate__animated wow"
                  src={DummyImage}
                  alt="DummyImage"
                />
              </NavLink>
            </div>
          </div>
          <div className="grid-items">
            <p
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              Sparen Sie über 50 % Ihrer üblichen Kosten ein. Wir erstellen und
              pflegen Ihr Exposé auf allen Portalen.
            </p>
            <p
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              Wir vermarkten Ihre Immobilie nicht nur auf einem Portal.
              Interessenten finden Ihre Immobilie auf über 100 Portalen.
            </p>
            <span
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              www.Immobilienscout24.de
            </span>
            <span
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              www.immonet.de
            </span>
            <span
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              www.kalaydo.de
            </span>
            <p
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              sowie mind. 100 weitere
            </p>
            <p
              className="animate__slideInUp animate__animated wow"
              data-wow-offset="100"
            >
              Wir erarbeiten Ihnen ein individuelles Angebot
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
